const adaptUserData = (data, labels) => {
  const user = [];
  const { firstName, lastName, email, phone, child } = data;
  user.push({
    label: labels.name,
    value: `${firstName ?? ""} ${lastName ?? ""}`.trim()
  });
  user.push({
    label: labels.child,
    value: `${child?.firstName ?? ""} ${child?.lastName ?? ""}`.trim()
  });
  user.push({ label: labels.email, value: email ?? "" });
  user.push({ label: labels.phone, value: phone ?? "" });
  return user.filter((el) => el.value !== "");
};
export {
  adaptUserData
};
//# sourceMappingURL=adapters.js.map
